import { useEffect } from 'react';
import { useLocation, useMatches, useRouteError } from 'react-router-dom';

import { logger } from '@/shared';

export function RootRouteErrorElement() {
  const routeError = useRouteError();
  const location = useLocation();
  const matches = useMatches();
  const activeRoute = matches[matches.length - 1];

  useEffect(() => {
    logger.error(
      'router errorElement failure',
      {
        surface: 'router',
        operation: 'route.errorElement',
        pathname: location.pathname,
        routeId: activeRoute?.id,
      },
      routeError
    );
  }, [activeRoute?.id, location.pathname, routeError]);

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background px-6 text-center">
      <div className="max-w-md space-y-3">
        <h1 className="text-xl font-semibold text-foreground">Something went wrong</h1>
        <p className="text-sm text-muted-foreground">
          We could not load this page. Please refresh and try again.
        </p>
      </div>
    </div>
  );
}
